import createVueApp from '@/common/createApp'

const renderNew = async(props) => {
  const { default: NewPage } = await import('@/vue_widgets/admin/moments/batches/new.vue')
  createVueApp(NewPage, { props })
}

Styxie.Initializers.AdminMomentsBatches = {
  // Cross-business all-batches index (the "Batches" tab on Moments Admin).
  index: async(props) => {
    const { default: IndexPage } = await import('@/vue_widgets/admin/moments/batches/index.vue')
    createVueApp(IndexPage, { props })
  },
  new: renderNew,
  // create renders :new on validation failure; styxie keys off action_name
  create: renderNew,
  show: async(props) => {
    const { default: ShowPage } = await import('@/vue_widgets/admin/moments/batches/show.vue')
    createVueApp(ShowPage, { props })
  },
  // Form-source workflow's drafting page. Distinct surface from #show
  // because the editing affordances + validation rules are different
  // (build mode vs. moderation mode).
  fill: async(props) => {
    const { default: FillPage } = await import('@/vue_widgets/admin/moments/batches/fill.vue')
    createVueApp(FillPage, { props })
  },
  checkins: async(props) => {
    const { default: CheckinsPage } = await import('@/vue_widgets/admin/moments/batches/checkins/index.vue')
    createVueApp(CheckinsPage, { props })
  }
}
